module.exports = __webpack_public_path__ + "static/media/jiffylube2.6fb20d70.png";